import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  selectRulesLoading,
  selectRulesError,
} from '../../../store/selectors/rules.selector';
import { Store } from '@ngrx/store';
import { marked } from 'marked';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrl: './description.component.scss',
  standalone: false,
})
export class DescriptionComponent implements OnChanges {
  constructor(private store: Store) {}

  @Input() description: string | undefined = undefined;
  @Input() behaviorSummary: string | undefined = undefined;
  descriptionItems: string[] = [];
  behaviorSummaryHtml: string = '';
  loading$ = this.store.select(selectRulesLoading);
  error$ = this.store.select(selectRulesError);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['description'] || changes['behaviorSummary']) {
      this.processDescription();
      if (this.behaviorSummary) {
        this.behaviorSummaryHtml = marked(this.behaviorSummary) as string;
      }
    }
  }

  processDescription(): void {
    if (this.description)
      this.descriptionItems = this.description
        .split('.')
        .map((item) => item.trim())
        .filter((item) => item.length > 0)
        .map((item) => {
          // Add styling for flow range (numbers with t/h)
          return item.replace(
            /(\d+-\d+ t\/h)/g,
            '<span class="flow-range">$1</span>',
          );
        });
  }
}
